import { render, staticRenderFns } from "./ImageCompress.vue?vue&type=template&id=5b16f7d2&scoped=true"
import script from "./ImageCompress.vue?vue&type=script&lang=js"
export * from "./ImageCompress.vue?vue&type=script&lang=js"
import style0 from "./ImageCompress.vue?vue&type=style&index=0&id=5b16f7d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16f7d2",
  null
  
)

export default component.exports